import {combineReducers} from 'redux';
import {managementReducer} from './management';

export const agencyFeedReducer = combineReducers({
  management: managementReducer,
});
